import Model, { attr, hasMany, type AsyncHasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type BookmarkModel from './bookmark';
import type ThemeModel from './theme';

type Confidences = { low: number; medium: number; high: number };

export default class OrganisationModel extends Model {
  declare [Type]: 'organisation';
  @attr('string') declare roadmap_url: string;
  @attr('string') declare name: string;
  @attr('number') declare first_day_of_week: number;
  @attr('number') declare bon_horizon: number;
  @attr('number') declare bon_price_person_week: number;
  @attr('number') declare bon_clv: number;
  @attr('number') declare capacity_product_development_fte_count: number;
  @attr('number') declare capacity_parallel_initiatives_count: number;
  @attr declare mission: unknown;
  @attr declare vision: unknown;
  @attr declare customer_values: unknown;
  @attr({ defaultValue: 'nl-NL' }) declare locale: string;
  @attr declare metadata: unknown;
  @attr({
    defaultValue() {
      return {
        low: 2,
        medium: 1.5,
        high: 1.25,
      };
    },
  })
  declare bon_investment_confidences: Confidences;

  @attr({
    defaultValue() {
      return {
        low: 0.25,
        medium: 0.5,
        high: 0.75,
      };
    },
  })
  declare bon_return_confidences: Confidences;

  @hasMany('bookmark', {
    async: true,
    inverse: 'organisation',
  })
  declare bookmarks: AsyncHasMany<BookmarkModel>;
  @hasMany('theme', {
    async: true,
    inverse: null,
  })
  declare themes: AsyncHasMany<ThemeModel>;
  @attr('number', {
    defaultValue: 33,
  })
  declare bucket_size_vision: number;
  @attr('number', {
    defaultValue: 33,
  })
  declare bucket_size_customer_request: number;
  @attr('number', {
    defaultValue: 33,
  })
  declare bucket_size_operations: number;

  @attr declare unavailable_time: unknown;
}
